import React from 'react';

import {formatString} from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

import {getConnectionContent} from '../ConnectionPage/connectionContentService';
import {useConnectionContext} from '../ConnectionPage/ConnectionContext';

const ProgressBar = ({progress, className}) => (
    <div className={twx('relative h-3 w-full overflow-hidden rounded-full bg-primary-dark-5 ml:bg-romance', className)}>
        <div
            className='h-full rounded-full bg-tertiary transition-all duration-0 ease-in-out'
            style={{width: `${progress}%`}}
        />
    </div>
);

const ConnectionProgress = ({className, progressBarClassName}) => {
    const {estimationDescription} = getConnectionContent();
    const {connectionState} = useConnectionContext();
    const {progress, remainingTime} = connectionState;

    return (
        <div
            role='progressbar'
            aria-valuenow={Math.floor(progress)}
            aria-valuemin='0'
            aria-valuemax='100'
            aria-live='polite'
            className={twx('w-full', className)}
        >
            <ProgressBar progress={progress} className={progressBarClassName} />
            <p className='mt-4'>{formatString(estimationDescription, remainingTime)}</p>
        </div>
    );
};

export default ConnectionProgress;
